
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import ChatMixin from '@/views/mixins/ChatMixin'
import {mapGetters} from 'vuex'

export default {
mixins: [ChatMixin],
components: {
Group,
Cell,
XInput,
XButton,
Scroller,
Loading,
Toast,
InlineLoading
},
computed: {
...mapGetters([
'fontColor',
'bannerColorStart',
'bannerColorEnd'
])
},
methods: {
inputClicked() {
if (this.$refs.phoneInput) {
this.$refs.phoneInput.focus();
this.$refs.phoneInput.style.borderColor = this.fontColor;
}
},
adjustInputPosition(flag){
if (flag) {
this.$refs.phoneInput.style.borderColor = this.fontColor;
}else {
this.$refs.phoneInput.style.borderColor = 'rgba(232,232,232,1)';
}

setTimeout(function(){
document.body.scrollTop = document.body.scrollHeight;
}, 300);
},
}
}



// WEBPACK FOOTER //
// ./src/views/colortheme/Chat.vue